import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Toaster } from '../ui/sonner';
import { GlobalSearchDrawer, SearchTrigger } from '../search/GlobalSearchDrawer';
import RBACLinkWarning from '../common/RBACLinkWarning';
import { useAuth } from '../../lib/auth';
import { NotificationCenter } from './NotificationCenter';
import TrustControl from '../common/TrustControl';
import { Sheet, SheetContent, SheetTrigger } from '../ui/sheet';
import { Button } from '../ui/button';
import { Menu } from 'lucide-react';

export function Layout() {
  const { user } = useAuth();
  const [showWarning, setShowWarning] = useState(false);
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  // Check for RBAC link status after login
  useEffect(() => {
    if (user) {
      // Check if user came from Microsoft login (has rbac_linked property)
      const storedUser = localStorage.getItem('user');
      if (storedUser) {
        try {
          const userData = JSON.parse(storedUser);
          if (userData.rbac_linked === false) {
            setShowWarning(true);
          }
        } catch (e) {
          // Ignore parse errors
        }
      }
    }
  }, [user]);

  // Get user data with rbac_linked status
  const getUserWithRbac = () => {
    try {
      const storedUser = localStorage.getItem('user');
      if (storedUser) {
        return JSON.parse(storedUser);
      }
    } catch (e) {
      // Ignore
    }
    return user;
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <GlobalSearchDrawer />
      <Sidebar />
      <div className="lg:hidden fixed top-4 left-4 z-40" data-testid="mobile-nav-trigger-wrap">
        <Sheet open={mobileNavOpen} onOpenChange={setMobileNavOpen}>
          <SheetTrigger asChild>
            <Button variant="outline" size="icon" className="h-10 w-10 rounded-full bg-white shadow-sm border-slate-200" data-testid="mobile-nav-trigger">
              <Menu className="h-4 w-4" />
            </Button>
          </SheetTrigger>
          <SheetContent side="left" className="w-[88vw] max-w-[360px] p-0">
            <Sidebar mobile />
          </SheetContent>
        </Sheet>
      </div>
      <div className="fixed top-4 right-6 z-40 flex items-center gap-2" data-testid="top-right-quick-actions">
        <SearchTrigger />
        <TrustControl />
        <NotificationCenter />
      </div>
      <main className="lg:pl-64 min-h-screen">
        <div className="p-4 lg:p-6 max-w-[1400px] mx-auto">
          {/* Each page handles its own contextual filters */}
          <Outlet />
        </div>
      </main>
      <Toaster position="top-right" />
      
      {/* RBAC Link Warning Popup */}
      <RBACLinkWarning 
        user={getUserWithRbac()}
        onDismiss={() => setShowWarning(false)}
        onContactAdmin={() => {
          // Could open mailto link or show admin contact
          window.location.href = 'mailto:admin@securado.com?subject=RBAC%20Access%20Request';
        }}
      />
    </div>
  );
}

